import { useState, useEffect } from 'react'

export default (key: string, initialValue:string = '') => {

    const [value, setValue] = useState<string>(() => {
        return localStorage.getItem(key) as string || initialValue
    })

    useEffect(() => {
        if (value === '' || value === null || value === undefined) localStorage.removeItem(key)  // logged out: keep no trace (CASA 6.6.1)
        else localStorage.setItem(key, value)
    }, [key, value])

    return [value, setValue] as const
}